import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Commodities from "@/pages/Commodities";
import CommodityDetail from "@/pages/CommodityDetail";
import About from "@/pages/About";
import Expertise from "@/pages/Expertise";
import Why from "@/pages/Why";
import Export from "@/pages/Export";
import Contact from "@/pages/Contact";
import { Privacy, Mentions } from "@/pages/Legal";

import Login from "@/pages/admin/Login";
import Admin from "@/pages/admin/Admin";
import AuthCallback from "@/pages/admin/AuthCallback";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback (session_id in URL fragment) before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/matieres-premieres" element={<Commodities />} />
        <Route path="/matieres-premieres/:slug" element={<CommodityDetail />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/pourquoi-nous" element={<Why />} />
        <Route path="/exportation" element={<Export />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/politique-confidentialite" element={<Privacy />} />
        <Route path="/mentions-legales" element={<Mentions />} />
      </Route>

      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
